module.exports = __webpack_public_path__ + "static/media/Nutshell.dd5ed641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fallbacks/about/Nutshell.jpg
// module id = 596
// module chunks = 8